import { message } from 'antd';
import { takeLatest } from 'redux-saga/effects';
import { ProjectAPI } from 'api/project';
import { updateProjectPhaseDatesAction } from 'data/projects/actions';
import { logger } from 'services';
function* updateProjectPhaseDates(action) {
    const { data, options } = action.payload;
    const { projectId, phaseId, startDate, dueDate } = data;
    try {
        const updatedPhase = yield ProjectAPI.updateProjectPhase(projectId, phaseId, {
            startDate,
            dueDate
        }, options === null || options === void 0 ? void 0 : options.isSync);
        if (updatedPhase && (options === null || options === void 0 ? void 0 : options.toggleUpdating)) {
            options.toggleUpdating(false);
        }
    } catch (error) {
        message.error('There was an error processing your request.');
        logger.error('unable to update project phase', {
            error,
            data
        });
    }
}
export const watchUpdateProjectPhaseDatesSaga = function*() {
    yield takeLatest(updateProjectPhaseDatesAction.type, updateProjectPhaseDates);
};
